import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElasticstackComponent } from './simple-icons-elasticstack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElasticstackComponent ],
    exports:      [ SimpleIconsElasticstackComponent ],
    bootstrap:    []
})
export class SimpleIconsElasticstackModule {}
